// Importiere die Firebase App und Firestore 'compat' Versionen
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';

// Deine Firebase-Konfiguration für die Web-App
const firebaseConfig = {
  apiKey: "AIzaSyB1nV0h3CHsG76YeYcOVes0nomDkZ8z6Ik",
  authDomain: "web1-23e03.firebaseapp.com",
  projectId: "web1-23e03",
  storageBucket: "web1-23e03.appspot.com", // Beibehaltung der Korrektur, üblicherweise .appspot.com
  messagingSenderId: "617944317614",
  appId: "1:617944317614:web:ab3a417172acb8eaccb73f"
  // measurementId ist optional und wurde nicht bereitgestellt
};

// Initialisiere Firebase, falls noch nicht initialisiert
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

// Initialisiere Firestore und exportiere es
const db = firebase.firestore();

export { db, firebase }; // firebase auch exportieren, falls Timestamp etc. benötigt wird